<template>

  <div id="app">
    <div >
      <search-bar  ref="searchBarComponent" @searchBarHeight="getSearchBarHeight">

          <div slot="search-cont">
              <div class="item" >
                <div class="item-label">职位名称</div>
                <div style="width: 300px;" >
                  <el-input placeholder="请输入内容" v-model="search.name" class="input-with-select" size="small" @keyup.enter.native='getList'>
                  </el-input>
                </div>
              </div>
              <div class="item" >
                <div class="item-label">部门名称</div>
                <div style="width: 300px;" >
                  <el-input placeholder="请输入内容" v-model="search.department" class="input-with-select" size="small" @keyup.enter.native='getList'>
                  </el-input>
                </div>
              </div>

              <!--  操作按钮 start -->
                <div class="item">
                  <el-button class="item-btn" type="primary" @click="getList">查询</el-button>
                  <el-button class="item-btn reset-btn" @click="clearQuery">重置</el-button>
                </div>
              <!--  操作按钮 end -->

          </div>


      </search-bar>

      <div class="operation-tool">
        <div @click="handleEdit()" class="tool-item"> <img src="../../../static/img/btn/add.png" /> 添加职位</div>
      </div>



    <div class="l-panel">
          <div class="panel-body">
      <el-table class="l-table" :data="dataList" style="width: 100%" @selection-change="handleSelectionChange" size="mini">

            <el-table-column prop="name" label="职位名称"  width="220" align="left"> </el-table-column>
            <el-table-column prop="deparment_name" label="所属部门" align="left" > </el-table-column>
            <el-table-column prop="remark" label="职位描述" align="left" width="200"> </el-table-column>
            <el-table-column prop="num" label="岗位人数" align="right" > </el-table-column>
            <el-table-column prop="ordid" label="排序" align="right" > </el-table-column>
            <el-table-column prop="status" label="状态" align="center" >
              <template slot-scope="{ row }">
                <span v-if="row.status == 1" style="color:#009933">激活</span>
                <span v-if="row.status == 0">非激活</span>
              </template>
            </el-table-column>

            <el-table-column  label="操作" align="center" width="400px">
               <template slot-scope="{row}">

                 <!-- <el-button size="mini" @click="handleEdit(row.id)"><i class="el-icon-edit-outline"></i>删除</el-button> -->
                 <el-button type="primary" @click="handleEdit(row.id)" plain  size="mini" >修改</el-button>
                 <el-button type="primary" @click="handleAuthorization(row)" plain  size="mini" >后台权限</el-button>
                 <el-button type="primary" @click="handleAuthorizationMini(row)" plain  size="mini" >小程序权限</el-button>

               </template>
            </el-table-column>

          </el-table>
          <div class="c-table-pager">
                <el-pagination  @current-change="handleCurrentChange" :total="total">
                </el-pagination>
          </div>
        </div>
    </div>


    </div>



  </div>

</template>

<script>
  import { WebUrl } from '@/api/index';
  import Message from '@/utils/message.js';
  export default{
    data:function(){
      return {
        search:{
          name:"",
          department:""
        },
        dataList:[],
        page:1,   //页码
        total:1,

      }
    },
    activated() {
      if( typeof(this.$route.query.name) !=undefined && this.$route.query.name ) {
        this.search.name = this.$route.query.name
      }
      if( typeof(this.$route.query.department) !=undefined && this.$route.query.department ) {
        this.search.department = this.$route.query.department
      }

      this.getList()
    },
    created() {
          this.$nextTick(() => {
            document.onselectstart = new Function("event.returnValue=false");
          });
    },
    methods:{
      //添加，编辑
      handleEdit(id){
        if(id){
          var ids=id
        }else{
          var ids = ''
        }
        this.$router.push({
          path:'/roleAdd?id='+ids
        })
      },
      //后台权限授权
      handleAuthorization(row) {
        this.$router.push({
          path: '/authorization?id=' + row.id + "&pName="+row.name + "&department=" + row.deparment_name
        })
      },
      //小程序权限授权
      handleAuthorizationMini(row) {
        this.$router.push({
          path: '/miniAuthorization?id=' + row.id + "&pName="+row.name + "&department=" + row.deparment_name
        })
      },

      clearQuery(){
        for(let key in this.search) {
          this.search[key] = ''
        }
        this.page = 1;
        this.getList()
      },
      // 获取操作栏展开收缩之后的高度
      getSearchBarHeight(val) {
          let sHeight = val;
          let fHeight = this.$refs.pageTableFilter ? this.$refs.pageTableFilter.clientHeight : 0;
          this.tableInitHeight = this.$util.setTableHeight(sHeight, fHeight);
      },
      //全部列表
      getList(){
        let param = {
          page:this.page
        }
        for(let key in this.search) {
          param[key] = this.search[key]
        }
        this.gets("adminrole/index",param).then((res) => {

          this.dataList = res.data.data.list;
          this.total = res.data.data.total;
        });
      },

        //翻页
        handleCurrentChange(val){
          this.page = val
          this.getList()

        },
        selectChange(){this.$forceUpdate()},

       handleSelectionChange(val){
         let array = []
         array = val.map((item)=>{array.push(item.id);return array})
         this.selectId = array[array.length-1]

       },

    }
  }
</script>

<style scoped>
  .content{padding:20px 0px;box-sizing: border-box;width: 100%;}
  .pagination{margin:20px auto;width: 100%;text-align: center;}


</style>



// WEBPACK FOOTER //
// src/view/entrepriseArchitecture/enterprisePosition.vue